export default "__VITE_ASSET__BmC2KWBL__"